import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.request`;
export const INIT = `${SCOPE}/INIT`;
export const APPLY_REQUEST = `${SCOPE}/APPLY_REQUEST`;
export const CHANGE_SIZE_CAP_ACTION = `${SCOPE}/CHANGE_SIZE_CAP_ACTION`;
export const CHANGE_SIZE_CAP = `${SCOPE}/CHANGE_SIZE_CAP`;
